import React from "react";
import { Provider, connect, useStore } from "react-redux";
import {
  applyFacetDialogFacet,
  hideFacetDialog,
} from "browse-media/redux/browseMediaActions";
import { Dialog } from "react-toolbox/lib/dialog";
import BrowseMediaFacetAutocomplete from "browse-media/components/BrowseMediaFacetAutocomplete";
import BrowseMediaFacetCheckboxes from "browse-media/components/BrowseMediaFacetCheckboxes";
import BrowseMediaFacetPublicationYears from "browse-media/components/BrowseMediaFacetPublicationYears";
import styles from "browse-media/components/BrowseMediaFacetDialog.css";

const BrowseMediaFacetDialog = ({
  availableTerms,
  displayName,
  onApply,
  onCancel,
  name,
  visible,
}) => {
  const store = useStore();

  return (
    <Dialog
      theme={styles}
      active={visible}
      title={displayName}
      onEscKeyDown={onCancel}
      onOverlayClick={onCancel}
      actions={[
        { label: "Cancel", onClick: onCancel },
        { label: "Apply", onClick: onApply },
      ]}
    >
      <Provider store={store}>
        {name === "contentDatePublished" ? (
          <BrowseMediaFacetPublicationYears />
        ) : availableTerms.length > 10 ? (
          <BrowseMediaFacetAutocomplete />
        ) : (
          <BrowseMediaFacetCheckboxes />
        )}
      </Provider>
    </Dialog>
  );
};

const mapStateToProps = state => {
  const {
    availableTerms,
    displayName,
    name,
    visible,
  } = state.browseMedia.facetDialog;
  return {
    availableTerms,
    displayName,
    name,
    visible,
  };
};

const mapDispatchToProps = dispatch => ({
  onApply: () => dispatch(applyFacetDialogFacet()),
  onCancel: () => dispatch(hideFacetDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  BrowseMediaFacetDialog,
);
